import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/appStore";
import { EAppReducers } from "store/white-list";

const getState = (state: RootState) => state[EAppReducers.IMAGE_UPLOAD];

export const imageUploadSelector = createSelector(getState, (state) => state);
